// extracted by mini-css-extract-plugin
export default {"grid":"order-form-billing_grid__1G3q6","grid2":"order-form-billing_grid2__wBU3y","text":"order-form-billing_text__beium","billing":"order-form-billing_billing__ZREWw"};